<ng-container *ngIf="visible">
  <div class="editor-display-container" [innerHTML]="text || '' | links_blank | linkify | richLinkDisplay | async"></div>
</ng-container>